const ellipsisChar = '\u2026';

export function getFileDepth(name: string, relativePath: string) {
  const parts = (relativePath || name).split('/');
  const depth = parts.length;
  return { parts, depth };
}

export function getPartsToDisplay(
  actualNameDisplayWidthPx: number | undefined = 0,
  actualPathDisplayWidthPx: number | undefined = 0,
  name: string,
  relativePath: string,
  approximateDisplayNameFontSize: number | undefined = 12
) {
  let hasSpaceForDirectory = false;
  const { depth, parts } = getFileDepth(name, relativePath);
  if (depth >= 2) {
    hasSpaceForDirectory =
      actualNameDisplayWidthPx <
      actualPathDisplayWidthPx - 2 * approximateDisplayNameFontSize;
  }

  const isDisplayRoootEllipsis =
    depth > 2 || (depth === 2 && !hasSpaceForDirectory);

  const result: string[] = [];

  if (isDisplayRoootEllipsis) {
    result.push(ellipsisChar);
  }

  if (depth === 1) {
    result.push(parts[0]);
  } else {
    if (!hasSpaceForDirectory) {
      result.push('/', parts[parts.length - 1]);
    } else {
      parts.splice(0, parts.length - 2);
      parts.forEach((part) => {
        result.push('/', part);
      });
    }
  }

  return {
    parts: result,
    isPreventNameCollapse: hasSpaceForDirectory,
  };
}

export type PartsToDisplay = ReturnType<typeof getPartsToDisplay>;
